import { TApiResRegions } from '@core/models';
import { createRehydrateReducer } from '@core/utils/rehydrate-reducer';
import { on } from '@ngrx/store';

import { setRegions } from '../actions/regions.actions';

export const regionsInitialState: TApiResRegions = [];

export const regionsReducer = createRehydrateReducer(
  { key: 'regionsReducer' },
  regionsInitialState,
  on(setRegions, (state, { value }): TApiResRegions => [...value])
);
